export const isCurrentPageMatch = (pathOrUrl, partialMatch) => {
  const { pathname } = new URL(pathOrUrl, window.location);
  const currentRoute = window.location.pathname;
  if (partialMatch) return currentRoute.includes(pathname);
  return currentRoute === pathname;
};

export const isMenuActive = menu =>
  menu.children.some(c => isCurrentPageMatch(c.to, c.partialMatch));
